/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { service } from '@ember/service';
import { action, computed } from '@ember/object';
import { setDiff, alias } from '@ember/object/computed';
import { isEmpty } from '@ember/utils';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import { matchYearLevel } from 'linced-app/utils/year-levels';
import { mapBy } from '@linc-technologies/linced-common/utils/arrays';

export default class FullSchoolDirectoryController extends Controller {
  matchYearLevel = matchYearLevel;

  @service
  session;

  @service
  strings;

  queryParams = ['allContacts'];
  allContacts = false;
  title = 'Full School Directory';

  @alias('session.school')
  school;

  @alias('session.school.jurisdiction')
  jurisdiction;

  @computed('jurisdiction')
  get useSecondaryContacts() {
    return this.jurisdiction === Jurisdiction.AU_NSW;
  }

  @tracked homeroomFilter = [];

  @setDiff('model.homerooms', 'homeroomFilter')
  remainingHomerooms;

  @computed('strings.homeroom')
  get homeroomFilterLabel() {
    return `Filter by ${this.strings.homeroom}`;
  }

  @tracked yearLevelFilter = [];

  @setDiff('school.yearLevels', 'yearLevelFilter')
  remainingYearLevels;

  @computed('model.learners.[]', 'yearLevelFilter.[]', 'homeroomFilter.[]')
  get filteredLearners() {
    let learners = this.get('model.learners');

    // Filter Learners by homeroom and year level (where chosen)
    let homeroomIds = mapBy(this.homeroomFilter, 'id');
    let years = this.yearLevelFilter;

    if (!isEmpty(homeroomIds) && homeroomIds.length > 0) {
      learners = learners.filter((person) => {
        return homeroomIds.includes(person.get('learner.homeroomId'));
      });
    }

    if (!isEmpty(years) && years.length > 0) {
      learners = learners.filter((person) => {
        return years.includes('' + person.get('currentYearLevel'));
      });
    }

    return learners;
  }

  @action
  selectHomeroom(homeroom) {
    this.homeroomFilter = [...this.homeroomFilter, homeroom];
  }

  @action
  removeHomeroom(homeroom) {
    this.homeroomFilter = this.homeroomFilter.filter((h) => h !== homeroom);
  }

  @action
  selectYearLevel(year) {
    this.yearLevelFilter = [...this.yearLevelFilter, year];
  }

  @action
  removeYearLevel(year) {
    this.yearLevelFilter = this.yearLevelFilter.filter((y) => y !== year);
  }
}
